import { getFirstArrayValue } from "@/utils/format";

import type { PaginatedDeployment } from "@/api/resources/deployments/types";

export const CACHED_DEPLOYMENT_KEY = "RECENT_DEPLOYMENT";

export const getIdealDeployment = (
  deployments: PaginatedDeployment[],
  cachedDeploymentId?: string | null,
): PaginatedDeployment => {
  const cachedDeployment = deployments.find((deployment) => deployment.id === cachedDeploymentId);
  if (cachedDeployment) return cachedDeployment;

  // get nextbest deployment - we assume there is atleast ONE Deployment per Workspace (Default created one)
  const nextBestDeployment = getFirstArrayValue(deployments);
  return nextBestDeployment as PaginatedDeployment;
};
